module.exports = {
    // endpointAPI: 'http://localhost:3000',
    endpointAPI: 'https://api.realexpert.ch',
    googleAPIKey: 'AIzaSyCs59KG4cQXHauGF7Lf-AzMaxUUyhkoYwk'
};
